/**
 * @fileoverview A busca e o filtro de responsável do Kanban, coluna a coluna.
 * Usado pelo quadro do CRM e pelo quadro compartilhado por link (só leitura).
 */

/** Os cards de cada coluna que passam na busca e no filtro de responsável. */
export const filterBoardLeads = (boardLeads, searchParam, assignedUserFilter) => {
  if (!searchParam && !assignedUserFilter) return boardLeads;

  const filtered = {};
  const search = searchParam ? searchParam.toLowerCase() : "";

  for (const [statusId, leads] of Object.entries(boardLeads)) {
    filtered[statusId] = leads.filter(lead => {
      // Assignee filter
      if (assignedUserFilter) {
        if (assignedUserFilter === "unassigned") {
          if (lead.assignedUserId) return false;
        } else {
          if (lead.assignedUserId !== assignedUserFilter) return false;
        }
      }

      // Search filter
      if (!search) return true;
      if ((lead.name || '').toLowerCase().includes(search)) return true;
      if ((lead.phone || '').toLowerCase().includes(search)) return true;
      if ((lead.email || '').toLowerCase().includes(search)) return true;
      if ((lead.cpf || '').toLowerCase().includes(search)) return true;
      if ((lead.serviceOrder || '').toLowerCase().includes(search)) return true;
      // Dynamic fields (new card format)
      if (lead.customFields?.fields) {
        return lead.customFields.fields.some(f =>
          (f.value?.toString() || '').toLowerCase().includes(search) ||
          (f.label || '').toLowerCase().includes(search)
        );
      }
      // Legacy flat customFields (WordPress)
      if (lead.customFields && !lead.customFields.fields) {
        return Object.values(lead.customFields).some(v =>
          (v?.toString() || '').toLowerCase().includes(search)
        );
      }
      return false;
    });
  }
  return filtered;
};
